<script setup lang="ts">
import { Widget } from "@happyreact/vue"
import { FeedbackProps } from "./Feedback.props"

defineProps<FeedbackProps>()

const runtimeConfig = useRuntimeConfig()
const token = runtimeConfig.public.HAPPYREACT_LIKES_TOKEN

const state = reactive({ reaction: null })

function handleReaction(params: any) {
  state.reaction = params.icon
}
</script>

<template>
  <div class="feedback-wrapper likes padded bg-grey-main md:bg-transparent">
    <div class="mouse flex items-center gap-4 py-4">
      <p>
        {{ $t("services.feedback.question") }}
      </p>

      <Widget
        :token="token"
        :resource="resource"
        :onReaction="handleReaction"
      />
    </div>

    <p v-if="state?.reaction" class="mouse-bold text-green-main mb-6">
      {{ $t("services.feedback.thanks") }}
    </p>
  </div>
</template>

<style lang="scss">
.likes {
  .hr-grid {
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 24px;
  }

  .hr-reaction {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;

    .hr-reaction-icon {
      display: none;
    }

    &:before {
      content: "";
      width: 24px;
      height: 24px;
    }
  }

  .hr-cell {
    &:first-of-type {
      .hr-reaction:before {
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill='%23C6C6C8' d='M4 11H1a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h3V11Zm18.539-.6A4 4 0 0 0 19.5 9H13V4c0-2.206-.794-4-3-4a1 1 0 0 0-.965.737L6 11v13h12.426a3.979 3.979 0 0 0 3.954-3.392l1.076-7a4 4 0 0 0-.917-3.208Z'/%3E%3C/svg%3E%0A");
      }
      .hr-reaction.hr-reaction-active:before {
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill='%2386CC7B' d='M4 11H1a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h3V11Zm18.539-.6A4 4 0 0 0 19.5 9H13V4c0-2.206-.794-4-3-4a1 1 0 0 0-.965.737L6 11v13h12.426a3.979 3.979 0 0 0 3.954-3.392l1.076-7a4 4 0 0 0-.917-3.208Z'/%3E%3C/svg%3E%0A");
      }
    }

    &:last-of-type {
      .hr-reaction:before {
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill='%23C6C6C8' d='M4 13H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h3v13Zm18.539.605A4 4 0 0 1 19.5 15H13v5c0 2.206-.794 4-3 4a1 1 0 0 1-.965-.737L6 13V0h12.426a3.979 3.979 0 0 1 3.954 3.392l1.076 7a4.002 4.002 0 0 1-.917 3.213Z'/%3E%3C/svg%3E%0A");
      }
      .hr-reaction.hr-reaction-active:before {
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill='%23B22222' d='M4 13H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h3v13Zm18.539.605A4 4 0 0 1 19.5 15H13v5c0 2.206-.794 4-3 4a1 1 0 0 1-.965-.737L6 13V0h12.426a3.979 3.979 0 0 1 3.954 3.392l1.076 7a4.002 4.002 0 0 1-.917 3.213Z'/%3E%3C/svg%3E%0A");
      }
    }
  }

  .hr-powered-by {
    display: none;
  }
}
</style>
